import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const displayArticles = articles.slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100/50">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-1 h-5 rounded-full bg-primary-500"></div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                影视资讯
              </h2>
            </div>
            <p className="text-sm text-foreground-500">
              最新影视动态、深度影评与追剧指南
            </p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多资讯 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {displayArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
              onMouseEnter={() => setHoveredId(article.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-48 flex-shrink-0 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className={`w-full sm:w-48 h-40 sm:h-full object-cover transition-transform duration-500 ${
                      hoveredId === article.id ? 'scale-105' : 'scale-100'
                    }`}
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-400">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-600">{article.publishDate}</span>
                      <span className="text-xs text-foreground-600">
                        <i className="ri-eye-line mr-0.5"></i>
                        {article.readCount.toLocaleString()}
                      </span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                  </div>
                  <div className="flex items-center gap-1.5 mt-3">
                    {article.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-2 py-0.5 rounded-md bg-background-200 text-foreground-500"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}